import { FormattedMessage, useIntl } from 'react-intl';
import React, { useContext } from 'react';
import { useModal } from 'store/modals';
import { useDeleteGroup } from 'services/2n/groups/delete-group';
import { DeleteButton } from '../../../../../../../../../form-elements/buttons/DeleteButton';
import { AccessManagement2NModalContext } from '../../../AccessManagement2NModalContext';

export const DeleteGroup = () => {

  const intl = useIntl();
  const { openModal } = useModal();
  const { selectedGroup, setSelectedGroup } = useContext(AccessManagement2NModalContext);
  const { deleteGroup, isLoading } = useDeleteGroup({
    onSuccess: () => setSelectedGroup(null),
  });

  function onDeleteGroup() {
    if (!selectedGroup) return;
    openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        title: intl.formatMessage(
          {
            id: 'deleteGroupConfirm',
          },
        ),
        content: intl.formatMessage(
          {
            id: 'accessGroupsDeleteConfirmContent',
          },
        ),
        onConfirm: () => deleteGroup(selectedGroup.Id),
      },
    });
  }

  return (

    <DeleteButton
      intl="accessGroupsDeletePermanently"
      onClick={() => onDeleteGroup()}
      disabled={!selectedGroup || isLoading}
    >
      <FormattedMessage id="accessGroupsDeletePermanently" />
    </DeleteButton>
   
  );
};
